import {AttributeLink, AttributeSetup} from '@acng/frontend-stargazer';
import {Watch} from '@acng/frontend-relativity';
import {guard} from '@acng/frontend-rubicon';
import {size} from '@acng/frontend-bounty/std/array.js';

import {animate} from 'acng/layout/service/animate-number.js';
import {ctxFriendship} from '../context/friendships.js';
import {FRIENDSHIP_STATE, STATE_PENDING} from '../../model';
import {compile} from '../service/template.js';
import {list} from '../service/cache.js';

/**
 * @group DOM Attribute
 */
const FRIEND_COUNT = 'data-friend-count';

AttributeSetup(FRIEND_COUNT, (name) => {
  const watch = Watch(`[${name}]`, ctxFriendship);

  AttributeLink(name, (element, type) => {
    type ||= STATE_PENDING;
    ASSERT: guard(type, FRIENDSHIP_STATE, `[${name}] type value`);

    watch(element, (element, friendship) => {
      const count = size(list(type));

      animate(element, count, friendship?.status == STATE_PENDING ? 0 : count);
    });
  });

  return compile;
});
